import { createContext, ReactNode, useMemo } from 'react'

import API from '../api/baseUrl'
import pathUrl from '../api/pathURL'
import { DataContextType, LicenseType } from '../types/interface'

export const DataContext = createContext<DataContextType>(null!)

const DataProvider = ({ children }: { children: ReactNode }) => {
  const getCityLicense = async (cityId: number) => {
    let licenseType: LicenseType[] = []
    await API.get(`${pathUrl.getCities}${cityId}`)
      .then((response) => {
        licenseType = response.data.licenses
      })
      .catch((error) => console.log(error))
    return licenseType
  }

  const value = useMemo(
    () => ({
      getCityLicense,
    }),
    []
  )

  return <DataContext.Provider value={value}>{children}</DataContext.Provider>
}

export default DataProvider
